export enum RatingColor {
  BLACK = 'black',
  BLUE = 'blue',
  YELLOW = 'yellow',
}
